import { UPDATE_BREADCRUMB } from 'constants/actionTypes';

const initialState = [];

export function breadcrumb(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_BREADCRUMB:
      return [...payload];
    default:
      return state;
  }
}
